var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "animate"
  }, [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Orders'
      }],
      "title": "All Orders"
    }
  }), _c('div', {
    staticClass: "bg-white w-full rounded-lg my-3 px-4 py-2.5"
  }, [_c('OrderFilter', {
    attrs: {
      "totalRows": _vm.totalRows,
      "paymentOption": _vm.paymentOption,
      "isLoading": _vm.isLoading
    },
    on: {
      "start": _vm.timeStart,
      "end": _vm.timeEnd,
      "paymentgateway": _vm.payment,
      "clientid": _vm.client,
      "ordernumber": _vm.order_number,
      "orderStatus": _vm.order_status,
      "isRenewal": _vm.status_renewal
    }
  }), _c('OrderTable', {
    attrs: {
      "items": _vm.items,
      "isLoading": _vm.isLoading,
      "perPage": _vm.perPage,
      "currentPage": _vm.currentPage
    },
    on: {
      "sort-by": _vm.handleSortBy
    }
  }), _vm.totalRows / _vm.perPage > 1 ? _c('div', {
    staticClass: "flex justify-between ml-1 items-center mt-3"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.currentPage) + "-" + _vm._s(_vm.perPage) + " "), _c('span', {
    staticClass: "text-gray-500 font-normal"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(parseInt(_vm.totalRows)) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    staticClass: "rounded-lg",
    attrs: {
      "total-items": Number(_vm.totalRows),
      "per-page": _vm.perPage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }